// Mirrors the category list enforced server-side in public/api/config.php
// (sssmil_categories()). Keep both in sync if categories ever change.
export const CATEGORIES = [
  { value: 'annual_return', label: 'Annual Return' },
  { value: 'annual_report', label: 'Annual Report' },
  { value: 'financial_results', label: 'Financial Results' },
  { value: 'shareholding_pattern', label: 'Shareholding Pattern' },
  { value: 'newspaper_publication', label: 'Newspaper Publication' },
  { value: 'corporate_announcements', label: 'Corporate Announcements' },
  { value: 'corporate_governance', label: 'Corporate Governance Report' },
];

export function categoryLabel(value) {
  const found = CATEGORIES.find((c) => c.value === value);
  return found ? found.label : value;
}
